import React from "react";
import { API_URL } from "src/scenes/App";
import axios from "axios";
import { useState } from "react";
import { Password, Email, ConfirmEmail, ErrorList, ErrorStrings } from "../components/ChangeEmailFields";
import {
    Button,
    StandardModal,
    StandardModalActionGroup,
    StandardModalSection,
    Toast
} from "src/components";

const ChangeEmailForm = (props) => {
    const { showDialog, handleClose, token, setEmail, isAccountOwner } = props;
    const [inputErrors, setInputErrors] = useState([]);
    const [formLoading, setFormLoading] = useState(false);
    const [formData, setFormData] = useState({
        password: "",
        email: "",
        confirmEmail: "",
    });

    const handleInputChange = (event, key) => {
        const updatedFormData = { ...formData, [key]: filterInputValue(event.target.value) };
        setFormData(updatedFormData);
    };

    const handleFormSubmit = () => {
        if (formLoading) {
            return;
        }

        setInputErrors([]);
        const errors = getErrors();

        if (errors.length > 0) {
            setInputErrors(errors);
            setFormLoading(false);
            return;
        }

        saveEmail(formData, setFormLoading, setInputErrors);
    };

    const saveEmail = async (formData, setSaveEmailLoading, setInputErrors) => {
        setSaveEmailLoading(true);
  
        const route = isAccountOwner ? "updateCompanyAccountEmail" : "updateEmployeeEmail";
        axios.put(`${API_URL}/company/${route}`, formData, {
            headers: {
                Authorization: "Bearer " + token
            }
        }).then(() => {
            setEmail(formData.email);
            setSaveEmailLoading(false);
            handleClose(false);
            return Toast.info("Your email was updated.");
        }).catch(error => {
            if (!error.hasFormErrors()) {
                Toast.error(error.getApiErrorDetails().message);
                return;
            }

            let errors = [];
            error.getFormErrors().forEach(({ field, message }) => {
                const responseMessage = "* " + message;
                const fieldKey = field;
                switch (fieldKey) {
                case "passwordInvalid":
                    ErrorStrings[ErrorList.PASSWORD_INVALID] = responseMessage;
                    errors.push(ErrorList.PASSWORD_INVALID);
                    return;

                case "emailInvalid":
                    ErrorStrings[ErrorList.EMAIL_INVALID] = responseMessage;
                    errors.push(ErrorList.EMAIL_INVALID);
                    return;
                        
                default:
                    //NO ERROR TO CATCH
                    return;
                }
            });

            setInputErrors(errors);
            setSaveEmailLoading(false);
        });
    };

    const validateEmail = (email) => {
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    };

    // prevents console warns when one of the input values are null
    const filterInputValue = (value) => [null].includes(value) ? "" : value;

    const getErrors = () => {
        let errors = [];
        
        if (formData.password === "" || formData.password === null) {
            errors.push(ErrorList.EMPTY_PASSWORD);
        }

        if (formData.email === "" || formData.email === null) {
            errors.push(ErrorList.EMPTY_EMAIL);
        } else if (!validateEmail(formData.email)) {
            errors.push(ErrorList.EMAIL_INVALID_FORMAT);
        } else {
            //confirm email
            if (formData.confirmEmail === "" || formData.confirmEmail === null) {
                errors.push(ErrorList.EMPTY_CONFIRM_EMAIL);
            } else if (formData.email !== formData.confirmEmail) {
                errors.push(ErrorList.CONFIRM_EMAIL_MISMATCHED);
            }
        }

        return errors;
    };
    
    return (
        <React.Fragment>
            <StandardModal
                open={showDialog}
                onClose={() => handleClose(false)}
                title="Change Account Email"
                widthMode="medium"
                footer={(
                    <StandardModalActionGroup $pushRight>
                        <Button
                            onClick={() => handleClose(false)}
                            size="0.875rem"
                            border="1px solid #000"
                            color="#000"
                            width="8.75rem"
                            style={{ borderRadius: "7px", boxShadow: "none" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={formLoading}
                            onClick={handleFormSubmit}
                            size="0.875rem"
                            backgroundColor="#171A22"
                            border="1px solid #171A22"
                            color="#fff"
                            width="8.75rem"
                            style={{ borderRadius: "7px", boxShadow: "none" }}
                        >
                            {formLoading ? "Saving..." : "Save"}
                        </Button>
                    </StandardModalActionGroup>
                )}
            >
                <StandardModalSection>
                    <Password placeholderDisabled={true} isEditable={!formLoading} formData={formData} onChangeFormData={handleInputChange} inputErrors={inputErrors}/>
                    <Email placeholderDisabled={true} isEditable={!formLoading} formData={formData} onChangeFormData={handleInputChange} inputErrors={inputErrors}/>
                    <ConfirmEmail placeholderDisabled={true} isEditable={!formLoading} formData={formData} onChangeFormData={handleInputChange} inputErrors={inputErrors}/>
                </StandardModalSection>
            </StandardModal>
        </React.Fragment>
    );
}; 

export default ChangeEmailForm;
